import * as THREE from 'three'
import Experience from '../Experience.js'
import Floor from "./Floor.js"

export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.config.debug

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('environment')
        }

        this.setAmbientLight()
        this.setDirectionalLight()
        this.setDarkModeListeners()
    }

    setFloor(width, depth, offset) {
        this.floor = new Floor(width, depth, offset)
    }

    setAmbientLight() {
        this.ambientLight = new THREE.AmbientLight(0xffffff, 0.4)
        this.scene.add(this.ambientLight)
    }

    setDirectionalLight() {
        this.directionalLight = new THREE.DirectionalLight(0xffffff, 2)
        this.directionalLight.position.set(5, 10, 5)
        this.scene.add(this.directionalLight)
    }

    setDarkModeListeners() {
        document.querySelector('.toggle-light button.light').addEventListener('click', () => {
            document.querySelector('.toggle-light button.light').classList.add('active')
            document.querySelector('.toggle-light button.dark').classList.remove('active')
            this.ambientLight.intensity = 0.4
            this.directionalLight.intensity = 2
            this.experience.dark_mode = false
        })

        document.querySelector('.toggle-light button.dark').addEventListener('click', () => {
            document.querySelector('.toggle-light button.light').classList.remove('active')
            document.querySelector('.toggle-light button.dark').classList.add('active')
            this.ambientLight.intensity = 0.1
            this.directionalLight.intensity = 0.1
            this.experience.dark_mode = true
        })
    }
}